import { Box, Flex, Button, StepIndicator } from '@hausgold/designsystem';
import { CheckCircled, ArrowLeftDrop, ArrowRightDrop } from '@hausgold/designsystem/icons';
import FluidMaxContainer from '../../FluidMaxContainer.js';
import NavigationButtonsLayoutContainer from '../../Layouts/NavigationButtonsLayoutContainer.js';
import RendererLayoutContainer from '../../Layouts/RendererLayoutContainer.js';
import WizardHeading from '../../WizardHeading.js';
import { ApiContext, WizardContext } from '../../../utils/contexts.js';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import { jsx } from '@emotion/react';
var ExtendedSteps = function ExtendedSteps(_ref) {
  var extendedSteps = _ref.extendedSteps,
    question = _ref.question,
    handleGoBack = _ref.handleGoBack,
    handleGoForward = _ref.handleGoForward,
    selectedValue = _ref.selectedValue;
  var _useContext = useContext(ApiContext),
    data = _useContext.data;
  var _useContext2 = useContext(WizardContext),
    position = _useContext2.position;

  /**
   * Positon based styles.
   * Copy from src/formwizard/src/wizard/Dialog/NavigationButtons.jsx
   */
  var buttonMargin = {
    base: 1,
    sm: null,
    md: 4
  };
  var buttonPaddingX = {
    base: 3.5,
    sm: 4,
    md: 10
  };
  var buttonPaddingY = {
    base: 2.5,
    sm: 3
  };
  var iconMargin = {
    base: 1.5,
    md: 2.5
  };
  var indicatorMarginX = {
    base: 2.5,
    sm: 3,
    md: 4
  };
  if (position === 'right' || position === 'top') {
    buttonMargin = {};
    buttonPaddingX = {};
    buttonPaddingY = {};
    iconMargin = {
      base: 1
    };
    indicatorMarginX = {
      base: 2.5
    };
  }
  var hasNextStep = extendedSteps.findIndex(function (step) {
    return step === question;
  }) < extendedSteps.length - 1;
  return jsx(Box, null, jsx(WizardHeading, null, data.extendedWizard.steps[question].title), jsx(FluidMaxContainer, null, jsx(RendererLayoutContainer, null, jsx(Flex, {
    flexDirection: "column",
    maxW: "394px",
    alignItems: "center",
    mx: "auto"
  }, data.extendedWizard.steps[question].options.choices.map(function (_ref2, index, origin) {
    var title = _ref2.title,
      value = _ref2.value;
    return jsx(Button, {
      key: value,
      variant: "muted",
      onClick: function onClick() {
        handleGoForward(value);
      },
      flexShrink: 0,
      flexGrow: 1,
      mb: index + 1 !== origin.length ? 4 : 0,
      isFullWidth: true,
      borderRadius: 0,
      fontSize: "md",
      fontWeight: "normal"
    }, selectedValue === value && jsx(CheckCircled, {
      top: "33%",
      right: "6%",
      position: "absolute",
      color: "green.400",
      boxSize: {
        base: 6,
        sm: 5,
        md: 7
      }
    }), title);
  }))), jsx(NavigationButtonsLayoutContainer, null, jsx(Button, {
    variant: "muted",
    as: "a",
    className: "back",
    mr: buttonMargin,
    px: buttonPaddingX,
    py: buttonPaddingY,
    onClick: handleGoBack
  }, jsx(ArrowLeftDrop, {
    boxSize: 2.5,
    mr: iconMargin
  }), "Zur\xFCck"), jsx(StepIndicator, {
    colorScheme: "red",
    mx: indicatorMarginX,
    flexGrow: "1",
    alignItems: "center",
    totalSteps: extendedSteps.length,
    currentStep: extendedSteps.findIndex(function (step) {
      return step === question;
    }) + 1
  }), jsx(Button, {
    variant: "primary",
    as: hasNextStep ? 'button' : 'a',
    className: "next",
    ml: hasNextStep ? buttonMargin : null,
    px: buttonPaddingX,
    py: buttonPaddingY,
    onClick: function onClick() {
      handleGoForward('weiter');
    }
  }, "Weiter", jsx(ArrowRightDrop, {
    boxSize: 2.5,
    ml: iconMargin
  })))));
};
ExtendedSteps.propTypes = {
  extendedSteps: PropTypes.arrayOf(PropTypes.string).isRequired,
  question: PropTypes.string.isRequired,
  handleGoBack: PropTypes.func.isRequired,
  handleGoForward: PropTypes.func.isRequired,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ExtendedSteps.defaultProps = {
  selectedValue: undefined
};
export { ExtendedSteps as default };